import * as z from 'zod'

import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

import {defineBrandPage, optionalSection} from '../../../brand/components/BrandPage'
import {GenericAssetSchema, GenericContentSchema, GenericSectionSchema} from '../../../brand/lib/types/contentful'

// Showcase needs the MIME type to distinguish images from videos.
const ShowcaseAssetSchema = GenericAssetSchema.unwrap().extend({
  fields: GenericAssetSchema.unwrap()
    .shape.fields.unwrap()
    .extend({
      asset: AssetSchema.unwrap().extend({
        fields: AssetSchema.unwrap().shape.fields.extend({
          file: AssetSchema.unwrap().shape.fields.shape.file.extend({contentType: z.string().optional()}),
        }),
      }),
    }),
})

const ShowcaseContentSchema = GenericContentSchema.unwrap().extend({
  fields: GenericContentSchema.unwrap()
    .shape.fields.unwrap()
    .extend({
      media: safeOptional(z.array(ShowcaseAssetSchema)),
    }),
})

export type ShowcaseContent = z.infer<typeof ShowcaseContentSchema>

export const homePage = defineBrandPage({
  intro: optionalSection('intro', GenericContentSchema, entry => entry),
  hero: optionalSection('hero', GenericContentSchema, entry => entry),
  dataMarquee: optionalSection('dataMarquee', GenericContentSchema, entry => entry),
  showcase: optionalSection('showcase', ShowcaseContentSchema, entry => entry),
  features: optionalSection('featuresSection', GenericSectionSchema, entry => entry),
  ctaBanner: optionalSection('ctaBanner', GenericContentSchema, entry => entry),
  testimonials: optionalSection('testimonialsSection', GenericSectionSchema, entry => entry),
  customerStories: optionalSection('customerStories', GenericContentSchema, entry => entry),
  footer: optionalSection('footerSection', GenericSectionSchema, entry => entry),
  interfaceText: optionalSection('interfaceText', GenericSectionSchema, entry => entry),
})
